
import React, { Component } from 'react';
import './jsx/Config/Init';
import { Link, Redirect } from "react-router-dom";
import {pageReload} from './util/PageReload';
import { loadProgressBar } from 'axios-progress-bar'
import 'axios-progress-bar/dist/nprogress.css'
import OrderHandler from './app/User/Handler/OrderHandler';
import { TableSessionType } from './app/Common/Enum/TableSessionType';
import DeliveryPriceCalculator from './app/User/SelectDeliveryLocation/helper/DeliveryPriceCalculator';
import DeliveryDetail from './Model/DeliveryDetail';
import TableSearchComponent from './components/TableSearchComponent.js';
import { getImageFullUrl, isFullUrl } from './app/Common/Enum/helper';

class AppMain extends Component {
    constructor(props) {
        super(props);
        this.state = {
            index: 1,
            table: null,
            merchant: null,
            redirect: false,
            banners: [],
            animate: null,
            kickstart: null
        };

        this.loadMerchant = this.loadMerchant.bind(this)
        this.changeLang = this.changeLang.bind(this)
        this.changeSlide = this.changeSlide.bind(this)
        this.showSlides = this.showSlides.bind(this)
        this.startOrder = this.startOrder.bind(this)
        this.changeLangUI = this.changeLangUI.bind(this)
    }

    componentWillMount() {
        let me = this;
        firebase.database().ref(firebase_path + '/tables/' + table_id).on('value', snapshot => {
            let item = snapshot.val()
            item.key = snapshot.key
            me.setState({
                table: item
            })
            me.loadMerchant(item.merchant_id)
            me.loadAdvertisement(item.merchant_id)
        });
    }

    componentWillUnmount() {
        firebase.database().ref(firebase_path + '/table/').off('value');
        firebase.database().ref(firebase_path + '/merchants/').off('value');
    }

    getMerchantCoordinate = () => {
        let coordinateStr = this.props.app.getMerchantSettingValue('merchant_outlet_coordinate')
        if (coordinateStr) {
            let components = coordinateStr.split(",")
            return {
                lat: parseFloat(components[0]),
                lng: parseFloat(components[1]),
            }
        }
    }
    geocode = (coordinate, callback) => {
        let merchantCoordinate = this.getMerchantCoordinate() // this.state.merchantCoordinate
        var service = new google.maps.DistanceMatrixService();
        service.getDistanceMatrix(
            {
                origins: [merchantCoordinate],  // , "Aeon Bukit Tinggi"
                destinations: [coordinate], // , "GM Klang"
                travelMode: 'DRIVING',
            }, (response, status) => {
                if (status == 'OK') {
                    let origins = response.originAddresses;
                    let destinations = response.destinationAddresses;

                    for (let i = 0; i < origins.length; i++) {
                        let results = response.rows[i].elements;
                        for (let j = 0; j < results.length; j++) {
                            const element = results[j];
                            let data = {
                                // element: results[j],
                                distance_text: element.distance.text,
                                duration_text: element.duration.text,
                                distance: element.distance.value,
                                duration: element.duration.value,
                                from: origins[i],
                                to: destinations[j],
                            }
                            callback(DeliveryPriceCalculator.calculatePrice(data))
                            $(document).trigger('AppMain.doneCalculateDeliveryPrice')
                            return
                        }
                    }
                  }
            });
    }

    componentDidUpdate() {
        if (!this.isDoneGeocode) {
            let merchantCoordinate = this.getMerchantCoordinate() // this.state.merchantCoordinate
            if (!merchantCoordinate) {
                return
            }
            this.isDoneGeocode = true

            const params = new URLSearchParams(window.location.search)
            // for (const param of params) {
            //     console.log(param)
            // }
            if (params.get("coordinate") && params.get("address")) {
                this.setState({
                    isNeedGeocode: true,
                })
                let address = params.get("address")
                let addressComponents = address.split(",")
                let streetNumber = (addressComponents.shift() || "").trim()
                addressComponents.forEach((component, index) => {
                    addressComponents[index] = component.trim() + ","
                })
                let getDestinationCoordinate = params.get("coordinate").split(",")
                getDestinationCoordinate = {
                    lat: parseFloat(getDestinationCoordinate[0]),
                    lng: parseFloat(getDestinationCoordinate[1]),
                }

                this.geocode(getDestinationCoordinate, (distanceData) => {
                    OrderHandler.setTableSessionType(TableSessionType.DELIVERY)
                    OrderHandler.setDeliveryDistanceData(distanceData)
                    OrderHandler.setDeliveryAddressComponents(addressComponents)
                    OrderHandler.setDeliveryStreetNumber(streetNumber)
                    OrderHandler.setDeliveryCoordinate(getDestinationCoordinate)

                    let deliveryDetail = new DeliveryDetail()
                    deliveryDetail.lat = getDestinationCoordinate.lat
                    deliveryDetail.lng = getDestinationCoordinate.lng
                    deliveryDetail.addressComponents = addressComponents
                    deliveryDetail.deliveryCharge = distanceData.price
                    deliveryDetail.distance = distanceData.distance
                    deliveryDetail.duration = distanceData.duration
                    deliveryDetail.streetNumber = streetNumber

                    deliveryDetail.baseCharge = distanceData.basePrice
                    deliveryDetail.processingFee = distanceData.processingFee
                    deliveryDetail.merchantCoverFee = distanceData.merchantCoverFee

                    OrderHandler.setDeliveryDetail(deliveryDetail)
                    this.setState({
                        redirectToCategoryPage: true
                    })
                })
            }
        }
    }

    componentDidMount() {
        loadProgressBar()
        this.props.app.loadTableIfNull();

        let me = this;
        let kickstart = setInterval(function () {
            me.showSlides(1);
        }, 2000)

        this.setState({
            kickstart: kickstart
        })

        if (this.props.app.isReadyFor(this)) {
            // this.showSlides(1);
            this.changeLangUI(selectedLang);
        }

        $(document).trigger('AppMain.componentDidMount.complete')

        const params = new URLSearchParams(window.location.search)
        if (params.get("coordinate") && params.get("address")) {
            this.setState({
                isNeedGeocode: true,
            })
        }
        if (params.get("source") && params.get("source") == 'omp') {
            localStorage.setItem('source', 'omp')
        }
    }

    loadMerchant(merchantID) {
        let me = this
        merchantID = parseInt(merchantID)
        firebase.database().ref(firebase_path + '/merchants/').off('value')
        firebase.database().ref(firebase_path + '/merchants/' + merchantID).on('value', snapshot => {
            let item = snapshot.val()
            item.key = snapshot.key
            me.setState({
                merchant: item
            }, () =>
                this.loadCountrys()
            )
        });
    }

    loadAdvertisement = (merchantID) =>{
        firebase.database().ref(firebase_path + '/advertisement_banners/').off('value')
        firebase.database().ref(firebase_path + '/advertisement_banners/').on('value', snapshot => {
            let banners = []
            snapshot.forEach(childSnapshot => {
                let item = childSnapshot.val()
                item.key = childSnapshot.key

                if(item.status_id == 1 && item.image_path){
                    if (item.merchant_id == parseInt(merchantID) || item.merchant_id == "0") {
                        banners.push(item)
                    }
                }
            })

            this.setState({
                banners: banners
            })
        });
    }

    startOrder(e) {
        e.stopPropagation()

        $.ajax({
            url: `/${table_id}/entermainpage`,
            type: 'get',
            data: {},
            success: (response) => {
                // alert("success")
                pageReload.goTo(window.location.href.split('?')[0] + `?lang=${selectedLang}`)
            }
        })
    }

    changeLang(e, value, index) {
        e.stopPropagation()
        this.changeLangUI(value, index);
        selectedLang = value;
        this.props.app.changeLanguage(value)
        return
    }

    changeLangUI(language, index) {
        var i;
        var btn = document.getElementsByClassName("btn-sm");
        for (i = 0; i < btn.length; i++) {
            btn[i].className = "btn btn-sm btn-default"
        }
        if (btn.length == 0) {
            return
        }
        if (language) {
            btn[index].className = "btn btn-sm btn-primary"
        }
    }

    changeSlide(e) {
        e.stopPropagation()
        let index = e.currentTarget.dataset.id * 1

        if(this.state.animate){
            clearInterval(this.state.animate);
        }

        this.showSlides(index);
    }

    showSlides(index) {
        let me = this;
        var i;
        var banners = document.getElementsByClassName("bannerContent");
        var dots = document.getElementsByClassName("dot");

        if (banners.length == 0) {
            return;
        }

        if(me.state.kickstart){
            clearInterval(me.state.kickstart);
            this.setState({
                kickstart: null
            })
        }

        const isVideo = (domElem) => {
            return domElem.dataset.type === "video"
        }

        for (i = 0; i < banners.length; i++) {
            banners[i].style.display = "none";
            dots[i].style.backgroundColor = "#bbb";

            if (isVideo(banners[i])) {
                banners[i].pause && banners[i].pause()
                banners[i].currentTime = 0
            }
        }

        let bannerToDisplay = banners[index - 1]
        let dotToDisplay = dots[index - 1]
        bannerToDisplay.style.display = "block";
        dotToDisplay.style.backgroundColor = "#f99f24";

        // Use the display time if non-zero, or default to 2 seconds
        let displayTime = Math.max(bannerToDisplay.dataset.screenTime * 1, 2) * 1000
        if (bannerToDisplay.dataset.type === "video") {
            // Auto start video after some delay
            setTimeout(() => {
                bannerToDisplay.play && bannerToDisplay.play()    
            }, 500)
        }
        let animate = setInterval(function () {
            index = index + 1;
            if (index > banners.length) { index = 1 }

            clearInterval(me.state.animate);
            me.showSlides(index);
        }, displayTime)
        this.setState({
            animate: animate
        })
    }

    obtainAdvertisementBanner = () =>{
        let listBanner = this.state.banners
        listBanner.sort(function (a, b) { return a.sequence - b.sequence })
        let li = listBanner.map((banner) => {
            let image_path = null
            if (banner.image_path && isFullUrl(banner.image_path)) {
                image_path = banner.image_path
            }
            else {
                image_path = getImageFullUrl(banner.image_path)
            }
            if (banner.type === "video") {
                // Need to set muted, else can't autoplay programmatically
                return <video className="bannerContent" data-screen-time={ banner.min_screen_time } data-type="video" controls key={banner.id} muted>
                    <source src={image_path} type="video/mp4" />
                </video>
            }
            return (listBanner.indexOf(banner) == 0) ?
                <img key={banner.id} className="bannerContent" data-type="image" data-screen-time={ banner.min_screen_time } style={{ display: "block" }} src={image_path} /> :
                <img key={banner.id} className="bannerContent" data-type="image" data-screen-time={ banner.min_screen_time } src={image_path} />
        })

        return li
    }

    obtainBannerIndicator = () =>{
        let me = this
        let listBanner = this.state.banners
        let li = listBanner.map((banner) => {
            let index = listBanner.indexOf(banner) + 1;
            return (listBanner.indexOf(banner) == 0) ?
                <span key={index} data-id={index} className="dot" style={{ backgroundColor: "#f99f24" }} onClick={me.changeSlide}></span> :
                <span key={index} data-id={index} className="dot" onClick={me.changeSlide}></span>
        })
        return li
    }

    isBothPickupAndDelivery = () => {
        return this.props.app.state.table.pickup && this.props.app.state.table.delivery
    }
    isPickupOrDelivery = () => {
        return this.props.app.state.table.pickup || this.props.app.state.table.delivery
    }

    loadCountrys() {
        $.ajax({
            url: "/country/list",
            type: "GET",
            success: allCountry => {
                this.setState({
                    countryList: allCountry,
                }, () => this.setState({ country: this.state.countryList.find( x => x.id == this.props.app.state.merchant.country_id ) }))
            },
            error: ajaxFails,
        })
    }

    checkingDisableLanguage = () =>{
        if (this.state.country) {
            if (this.props.app.isMerchantHasFeature('disable_language_bar_user_welcome_page')) {
                return
            }
            else {
                return <>
                    <div style={{ textAlign: "center", marginTop: "4%" }}>
                        {/* <!-- First step:  --> */}
                        {
                            this.state.country.language.map((lang, index) => {
                                lang.key = lang.value
                                return <button key={lang.key} data-id={lang.key} style={{ marginLeft: "10px", marginBottom: "5px", fontSize: "16px" }} type="button" className={`btn btn-sm ${lang.key == selectedLang ? "btn-primary" : "btn-default"}`} onClick={(e) => this.changeLang(e, lang.key, index)}>{lang.label}</button>
                            })
                        }
                    </div>
                    <div style={{ textAlign: "center" }}>
                        <i style={{ fontSize: "14px" }}>{lang.choose_lang}</i>
                    </div>
                </>
            }
        }
    }

    renderOrderButtons = () => {
        const isSkipSelectLocation = this.props.app.getMerchantSettingValue("allow_skip_select_location") == 1
        const deliveryButtonText = this.getDeliveryButtonText()
        const deliveryButton = isSkipSelectLocation ?
            <Link
                className="mainpg-btn"
                to={`/category/${this.props.match.params.tableQR}`}>
                <span style={{ fontSize: "18px" }}>{deliveryButtonText}</span>
            </Link> :
            <Link
                id="mainpage-btn-delivery"
                className="mainpg-btn"
                to={`/select_location/${this.props.match.params.tableQR}`}>
                <span style={{ fontSize: "18px" }}>{deliveryButtonText}</span>
            </Link>
        if (this.isBothPickupAndDelivery()) {
            return <>
                <Link
                    className="mainpg-btn"
                    onClick={() => {
                        OrderHandler.setTableSessionType(TableSessionType.PICKUP)
                    }}
                    to={`/category/${this.props.match.params.tableQR}`}>
                    <span style={{ fontSize: "18px" }}>{this.getPickupButtonText()}</span>
                </Link>
                { deliveryButton }
            </>
        }
        else if (this.props.app.state.table.pickup) {
            return <Link
                className="mainpg-btn"
                onClick={() => {
                    OrderHandler.setTableSessionType(TableSessionType.PICKUP)
                }}
                to={`/category/${this.props.match.params.tableQR}`}>
                <span style={{ fontSize: "18px" }}>{this.getPickupButtonText() || lang.app_name}</span>
            </Link>
        }
        else if (this.props.app.state.table.delivery) {
            return deliveryButton
        }
        else if(this.props.app.state.table.table_type_bitwise == 8){
            return <>
                <div style={{display: "flex", alignItems: "center", flexDirection: "column",}}>
                    <TableSearchComponent app={this.props.app} merchantId={this.props.app.state.table.merchant_id}/>
                </div>
                {
                    !this.props.app.isMerchantHasFeature('disable_check_in') &&
                    <>
                        <Link
                            id="mainpage-btn-checkin"
                            className="mainpg-btn"
                            to={{
                                pathname: `/check_in/${this.props.match.params.tableQR}`,
                                state: {
                                    hideFooter: true
                                }
                            }}>
                            <span style={{ fontSize: "18px" }}>{lang.check_in}</span>
                        </Link>
                        <div>
                            <span style={{color: "darkred", fontWeight: "bold", fontStyle:"italic"}}>
                                {lang.check_in_desc}
                            </span>
                        </div>
                    </>
                }
            </>
        }
        else {
            // Dine In
            return <>
                <Link
                    className="mainpg-btn"
                    to={`/category/${this.props.match.params.tableQR}`}>
                    <span style={{ fontSize: "18px" }}>{lang.app_name}</span>
                </Link>
                {
                    !this.props.app.isMerchantHasFeature('disable_check_in') &&
                    <>
                        <Link
                            id="mainpage-btn-checkin"
                            className="mainpg-btn"
                            to={{
                                pathname: `/check_in/${this.props.match.params.tableQR}`,
                                state: {
                                    hideFooter: true
                                }
                            }}>
                            <span style={{ fontSize: "18px" }}>{lang.check_in}</span>
                        </Link>
                        <div>
                            <span style={{color: "darkred", fontWeight: "bold", fontStyle:"italic"}}>
                                {lang.check_in_desc}
                            </span>
                        </div>
                    </>
                }
            </>
        }
    }

    disableBanner = () => {
        if (this.props.app.isMerchantHasFeature('disable_banner_at_user_welcome_page')) {
            return null
        }
        else {
            return <div className="banner">
                {this.obtainAdvertisementBanner()}
                <div className="indicator">
                    {this.obtainBannerIndicator()}
                </div>
            </div>
        }
    }

    getPickupButtonText = () => {
        const text = this.props.app.getMerchantSettingValue("main_page_pickup_button_text")
        let multiLingual = null
        if (text) {
            try {
                multiLingual = JSON.parse(text)
            }
            catch (e) {

            }
        }
        return multiLingual && multiLingual[selectedLang] || text || lang.self_pickup
    }
    getDeliveryButtonText = () => {
        const text = this.props.app.getMerchantSettingValue("main_page_delivery_button_text")
        let multiLingual = null
        if (text) {
            try {
                multiLingual = JSON.parse(text)
            }
            catch (e) {

            }
        }
        return multiLingual && multiLingual[selectedLang] || text || lang.delivery
    }

    render() {
        if (!this.props.app.isReadyFor(this)) {
            return <div></div>
        } else if (this.props.app.state.current_session != null || this.state.redirect || this.state.redirectToCategoryPage) {
            let link = "/category/" + this.props.match.params.tableQR
            return <Redirect to={link} push={!this.state.redirectToCategoryPage}/>
        }

        let image_path = this.props.app.state.merchant && this.props.app.state.merchant.getLogo()
        let isPickupTable = this.props.app.state.table.pickup

        let landingTable = this.state.table && this.state.table.table_type_bitwise == 8

        let squareImageStyle = this.props.app.isMerchantHasFeature('logo_use_square_image') ? { borderRadius: "0px" } : {}
        let SquareImageforLanding = this.props.app.isMerchantHasFeature('logo_use_square_image') ? { borderRadius: "0px" , float: "none"} : {float: "none"}
        let checkLandingTable = landingTable ?
            <>
                {this.props.app.state.merchant && this.props.app.state.merchant.logo_url ?
                <img src={image_path} style={SquareImageforLanding} />
                : ""}
            </> :
            <>
                {
                    this.props.app.state.merchant && this.props.app.state.merchant.logo_url ?
                    <img src={image_path} style={squareImageStyle} /> :
                    ""
                }
                <div style={{ display: "table", marginTop: "10%", textAlign: "center", width: "45%" }}>
                <h3 style={{ marginTop: "0px", marginBottom: "0px" }}>{lang.table_no}</h3>
                <h1 style={{ marginTop: "0px", marginBottom: "0px", fontSize: isPickupTable ? "50px" : "60px"  }}>
                    {this.state.table && ((this.state.table.pickup && lang.pickup) || this.state.table.name) || ""}
                </h1>
                </div>
            </>

        let merchantName = ""
        let branchName = ""
        let isBranch = false
        if(this.props.app.state.merchant){
            if(this.props.app.state.merchant.name.indexOf('-') >= 0){
                let arr = this.props.app.state.merchant.name.split('-');
                merchantName = arr[0];
                branchName = arr[1];
                isBranch = true;
            }
            else{
                merchantName = this.props.app.state.merchant.name;
            }
        }

        return (
            <div className={this.props.app.isReadyFor(this) ? "" : "hidden"}>
                {this.disableBanner()}

                <p style={{ marginTop: "10px", marginBottom: "0px", textAlign: "center", color: "#563f2f", fontWeight: "bold", fontSize: "28px" }}>
                    {lang.welcome_text}
                </p>

                {
                    this.isPickupOrDelivery() ?
                    <div id="logo" className="clearfix" style={{textAlign:"center"}}>
                        {
                            this.props.app.state.merchant && this.props.app.state.merchant.logo_url ?
                            <>
                                <img src={image_path} style={{...squareImageStyle, float:"none"}} />
                                {isBranch?
                                    <><h3 style={{ marginTop: "10px", marginBottom: "0px"}}>{merchantName}</h3><h3 style={{ marginTop: "0px", marginBottom: "0px"}}>{branchName}</h3></> :
                                    <h3 style={{ marginTop: "10px", marginBottom: "0px"}}>{merchantName}</h3>
                                }
                            </> : ""
                        }
                    </div> :
                    <div id="logo" className="clearfix">
                        {checkLandingTable}
                    </div>
                }

                {/* <p id="tableNum" style={{textAlign:"center"}}>{lang.welcome_text + " " + tableId}</p> */}

                <div className="float-bottom" style={{ textAlign: "center", marginTop: "4%" }}>
                    <LandingPagePromoText />
                    {this.renderOrderButtons()}
                </div>

                {/* <div className="float-bottom" style={{ textAlign: "center", marginTop: "2%" }}>
                    <FacebookLoginButton user={this.props.app.state.user} login={(user) => {
                        if (user != null) {
                            this.setState({
                                redirect: true
                            });
                        }
                    }} />
                </div> */}

            {this.checkingDisableLanguage()}
            </div>
        )
    }
}


const LandingPagePromoText = ({}) => {
    const langKey = `landing_page_promo_text_${window.merchant_id}`;
    if (!lang[langKey]) {
        return null
    }

    const nl2br =  (text) => {
        return text.split('\n').map(function(item, key) {
            return (
              <span key={key}>
                  {item}
                <br/>
              </span>
            )
        })
    }
    return <div style={{textAlign:"center", width: "80%", fontSize: "110%", margin: "30px auto 10px auto"}}>
        {nl2br(lang[langKey])}
    </div>
}

export default AppMain